/*
 * This module is currently not being used. Initially the design included it for customer selection
 * during manual case creation. However, the customer listing API is not available, and would require
 * significant work to develop. We keep this module here to be used when that API is ready.
 */
import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';

export const fetchCustomers = async ({ currentPage, pageSize }) => {
  const params = {
    offset: (currentPage - 1) * pageSize,
    limit: pageSize
  };

  const url = `${CM_BASE_URL}/alerts/customers`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw { message: 'Failed to fetch customers' };
    }
    return res.data;
  });
};
